import {isNil} from 'ramda';

import {GetManufacturersResponse} from '@dms/api/core';

export const getActiveManufacturerOptions = (
  manufacturers: GetManufacturersResponse | undefined
) => {
  if (isNil(manufacturers)) {
    return [];
  }

  return manufacturers
    ?.filter((manufacturer) => manufacturer.isActive)
    .map((manufacturer) => ({
      label: manufacturer.name,
      value: manufacturer.manufacturerId,
    }));
};
